export default __webpack_public_path__ + "static/media/cheque.21bbdd2f.svg";